export default __webpack_public_path__ + "static/media/recipe2.02f9c34c.png";